// import React, { useState } from 'react';
// import axios from 'axios';
// import YouTube from 'react-youtube';
import Main from "./components/Background/Main.jsx";
// import ts_bg from "./background"
// import ts_folk from "./background/folklore.png"



function main() {
 

  return (
    <main>
      <div>
        <Main className=""/>
      </div>
    </main>



  );
}

export default main;
